import { useParamsContext } from '../contexts/ParamsContext';

const useParams = () => useParamsContext();
export default useParams;
